import FileUploadImage from '../FileUploadImage/FileUploadImage';
import { useTranslation } from 'react-i18next';

function ImageUpload(props) {
    const { t } = useTranslation();
    const { register, formState, resetField, setSavedSelectedImage, savedSelectedImage, promotionSettings, setImage, setValue } = props;

    return (
        <>
            <div className="promo-fields-group promo-fields__border-bottom">
                <div className="promo-fields">
                    <div className="promo-field">
                        <>
                            <h5>{t("Upload a picture of your product")}*</h5>
                            <FileUploadImage register={register} formState={formState} resetField={resetField} imagePreview={true} setValue={setValue} setImage={setImage} inputName={"file_upload"} setSavedSelectedImage={setSavedSelectedImage} savedSelectedImage={savedSelectedImage} csrfToken={promotionSettings.csrfToken} />
                        </>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ImageUpload;